import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStatusCountCardLargeStyles = makeStyles<Theme>((theme) => ({
  link: {
    width: '100%'
  },
  card: {
    position: 'relative',
    padding: '16px',
    width: '100%',
    height: '324px',
    borderRadius: '10px',
    [theme.breakpoints.down(1135)]: {
      height: '498px'
    },
    [theme.breakpoints.down(960)]: {
      height: '150px'
    },
    [theme.breakpoints.down(860)]: {
      height: '135px'
    }
  },
  clickable: {
    cursor: 'pointer',
    transition: 'transform 0.15s ease-in-out',
    [theme.breakpoints.down('sm')]: {
      boxShadow: '0 0 8px 0 rgb(82 63 105 / 15%) !important'
    },
    '&:hover': {
      transform: 'scale3d(1.02, 1.02, 1)',
      boxShadow: '0 0 100px 0 rgb(82 63 105 / 13%) !important',
      [theme.breakpoints.down('sm')]: {
        boxShadow: '0 0 8px 0 rgb(82 63 105 / 11%) !important'
      }
    },
    '&:active': { transform: 'scale3d(1, 1, 1)' }
  },
  iconWrapper: {
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    marginBottom: '16px',
    [theme.breakpoints.down('sm')]: {
      position: 'absolute',
      right: '16px',
      top: 0,
      display: 'flex',
      alignItems: 'center',
      width: 'auto',
      height: '100%'
    }
  },
  avatar: {
    width: '144px',
    height: '144px',
    [theme.breakpoints.down('sm')]: {
      width: '100px',
      height: '100px'
    },
    [theme.breakpoints.down(320)]: {
      width: '80px',
      height: '80px'
    }
  },
  icon: { width: '96px', height: '96px' },
  title: {
    fontWeight: 800,
    marginTop: '-0.35rem',
    [theme.breakpoints.down('sm')]: {
      display: 'inline-block',
      width: '55%'
    }
  },
  subtitle: {
    color: 'grey',
    fontSize: '11px',
    marginBottom: '16px',
    [theme.breakpoints.down('sm')]: {
      display: 'inline-block',
      width: '55%'
    },
    [theme.breakpoints.down(860)]: {
      display: 'none'
    }
  },
  count: {
    fontSize: '62px',
    lineHeight: 1,
    marginBottom: '-8px',
    [theme.breakpoints.down(1400)]: {
      fontSize: '60px'
    },
    [theme.breakpoints.down(1300)]: {
      fontSize: '57px'
    },
    [theme.breakpoints.down(1234)]: {
      fontSize: '55px'
    },
    [theme.breakpoints.down(1134)]: {
      fontSize: '50px'
    },
    [theme.breakpoints.down(860)]: {
      fontSize: '45px'
    },
    [theme.breakpoints.down(600)]: {
      fontSize: '40px'
    },
    [theme.breakpoints.down(460)]: {
      fontSize: '37px'
    },
    [theme.breakpoints.down(340)]: {
      fontSize: '35px'
    },
    [theme.breakpoints.down(320)]: {
      fontSize: '25px'
    }
  }
}));
